import React from 'react';
import { Drawer } from '@mui/material';
import EmailContentForm from './EmailContentForm';

function SwipeableContentDrawer(props) {
  const {
    contentDrawerOpen, toggleDrawer, onSubmitFunction, notificationName
  } = props;

  return (
    <div>
      <Drawer
        anchor="right"
        open={contentDrawerOpen}
        onClose={() => toggleDrawer()}
      >
        <EmailContentForm
          submitText="Save"
          mainText={notificationName !== 'Add Notification' ? 'Edit Content' : 'Add New Content'}
          onSubmitFunction={onSubmitFunction}
          notificationName={notificationName}
        />
      </Drawer>
    </div>
  );
}

export default SwipeableContentDrawer;
